import axios from 'axios';
import { simulatedAgentSession } from './agentSession';

axios.defaults.headers.common['x-simulated-user'] = localStorage.getItem('simulatedUser');
axios.defaults.headers.common['x-simulated-agent'] = simulatedAgentSession('id');
axios.defaults.headers.common['X-CSRF-Token'] = document.querySelector('meta[name="csrf-token"]').getAttribute('content');
axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

const instance = axios.create();

export default axios;
